export const GOALS_LIST = [
  "SDG Index Score",
  "Goal 1: No Poverty",
  "Goal 2: Zero Hunger",
  "Goal 3: Good Health",
  "Goal 4: Quality Education",
  "Goal 5: Gender Equality",
  "Goal 6: Clean Water and Sanitation",
  "Goal 7: Renewable Energy",
  "Goal 8: Good Jobs and Economic Growth",
  "Goal 9: Industry, Innovation and Infrastructure",
  "Goal 10: Reduced Inequalities",
  "Goal 11: Sustainable Cities and Communities",
  "Goal 12: Ensure sustainable consumption and production patterns",
  "Goal 13: Climate Action",
  "Goal 14: Conserve and sustainably use the oceans, seas and marine resources for sustainable development",
  "Goal 15: Life on Land",
  "Goal 16: Peace, Justice and Strong Institutions",
];

export const YEARS = [2020, 2019, 2018];

export const UT = ["IND035","IND026","IND025","IND007","IND004","IND001","IND037","IND031","IND034"];
